<template>
    <div class="input-group">
        <div class="group flex-center" v-for="(item,index) in items">
            <div class="left-side">
                <div v-if="item.fields != undefined && item.fields.length > 0">
                    <input v-for="field in item.fields" v-bind:name="name + '[' + field.name +'][]'" v-bind:value="field.value" type="hidden"/>
                </div>
                <div class="group-title" v-html="item.title"></div>
                <div class="group-subtitle" v-html="item.subtitle"></div>
            </div>
            <div class="flex-filler"></div>
            <div class="right-side nowrap">
                <span @click="edit(index)" class="material-icons">create</span>&nbsp;
                <span @click="remove(index)" class="material-icons">cancel</span>
            </div>
        </div>
        <div class="form">
            <slot class="form-slot"></slot>
            <a @click.prevent="save()" class="button-submit-link" href="" >
                <div class="button-submit">
                    <span class="material-icons">add_circle_outline</span> Add
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {
            this.items = this.fields;
        },
        data:function() {
            return {
                items:[],
                otherFields:[]
            }
        },
        props:{
            name:{type:String,default:''},
            fields:{type:Array,default:function() { return []; }}
        },
        methods: {
            save:function() {
                var e = this;
                var $form  = $(this.$el).find('.form');
                var item = {
                    title:'',
                    subtitle:'',
                    fields: []
                }

                var fieldCount = $form.find('input, select').length;
                $form.find('input, select,textarea').each(function(index) {
                    if (index == 0) {
                        item.title = $(this).val();
                    } else if(index == 1) {
                        item.subtitle += $(this).val();
                        /*if (index < fieldCount - 1 && item.subtitle != ''){
                            if (item.subtitle.includes('19') || item.subtitle.includes('20')){
                                item.subtitle += ' – ';
                            }
                            else {
                                item.subtitle += ' • ';
                            }
                        }*/
                    }
                    item.fields.push({
                        name: $(this).attr('name'),
                        value: $(this).val()
                    });
                    $(this).val('');
                });
                this.items.push(item);
                setTimeout(function() {
                    e.$root.$setModalItemHeight();
                    setTimeout(function() {
                        e.$root.$positionModal();
                    },200);
                },100);
            },
            edit:function(index) {
                var $form  = $(this.$el).find('.form');
                var item = this.items[index];
                if (item.fields != undefined && item.fields.length > 0 ){
                    $form.find('input,select,textarea').val('');
                    $.each(item.fields, function (_,field) {
                        $form.find('input[name='+field.name+']').val(field.value);
                        $form.find('select[name='+field.name+']').val(field.value);
                        $form.find('textarea[name='+field.name+']').val(field.value);
                    })
                }
                this.remove(index);
                var e = this;
                setTimeout(function() {
                    e.$root.$setModalItemHeight();
                    setTimeout(function() {
                        e.$root.$positionModal();
                    },200);
                },100);

            },
            remove:function(index) {
                var e = this;
                var item = this.items[index];
                this.items.splice(this.items.indexOf(item), 1);
                setTimeout(function() {
                    e.$root.$setModalItemHeight();
                },100);
            }
        },
        mounted:function() {

        }
    }
</script>
